import { Controller } from "@hotwired/stimulus"
import { copyToClipboard } from "utils"

// Fetches a quick pay link for the customer (resurfacing an existing one or
// generating a fresh one server-side) and copies it to the clipboard.
export default class extends Controller {
  static targets = ["label"]
  static values = { url: String }

  connect() {
    const label = this.hasLabelTarget ? this.labelTarget : this.element
    this.originalLabel = label.innerText
  }

  async copy(event) {
    event.preventDefault()
    if (this.loading) return
    this.loading = true

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          Accept: "application/json",
        },
      })
      if (!response.ok) return

      const { url } = await response.json()
      await copyToClipboard(url)
      this.flashCopied()
    } finally {
      this.loading = false
    }
  }

  flashCopied() {
    const label = this.hasLabelTarget ? this.labelTarget : this.element
    clearTimeout(this.resetTimeout)
    label.innerText = "Copied!"
    label.classList.add("text-green-600")
    this.resetTimeout = setTimeout(() => {
      label.innerText = this.originalLabel
      label.classList.remove("text-green-600")
    }, 3000)
  }
}
